// Server-side authorization is the source of truth; these helpers only shape the UI.
export const can = (user, action) => (user?.permissions || []).includes(action);

export const canManage = (user) => can(user, "property:create") || can(user, "job:create");
export const isCleaner = (user) => user?.visibility === "assigned" || user?.role === "cleaner";
export const isPlatformAdmin = (user) => user?.platform_role === "platform_admin";
